module.exports = __webpack_public_path__ + "img/settings-general.77e3c18b.svg";